import { useCallback, useEffect, useState } from 'react';
import { useAppSelector, usePrevious } from '../index';
function isPropBetIsEditable(component) {
    return component.setSelectionsByBetId !== undefined;
}
export function usePropBetSelection(props) {
    const ticketSelection = useAppSelector((state) => {
        var _a;
        const selectionIds = props.ticket
            ?
                (_a = state.selections.byTicketId[props.ticket.id]) !== null && _a !== void 0 ? _a : []
            : [];
        const selections = selectionIds.map((selectionId) => state.selections.byId[selectionId]);
        return selections.find((selection) => selection.betId === props.bet.id);
    });
    const selectionStatus = useAppSelector((state) => state.selections.status);
    const previousSelectionStatus = usePrevious(selectionStatus);
    const [selection, setSelection] = useState(ticketSelection);
    const setSelectionIfEditable = useCallback((selection) => {
        if (isPropBetIsEditable(props.propBetComponent) && props.editable) {
            let updateSelectionByBetId = {};
            if (selection.betId) {
                updateSelectionByBetId = Object.assign(Object.assign({}, props.propBetComponent.selectionsByBetId), { [selection.betId]: selection });
            }
            props.propBetComponent.setSelectionsByBetId(updateSelectionByBetId);
            setSelection(selection);
        }
    }, [props.editable, props.propBetComponent.selectionsByBetId]);
    useEffect(() => {
        if (selectionStatus === 'success' && previousSelectionStatus === 'fetching') {
            setSelection(ticketSelection);
        }
    }, [selectionStatus]);
    return {
        selection,
        setSelectionIfEditable
    };
}
